import QS from 'qs';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    access: localStorage.getItem('access') || JSON.stringify(null),
  },
  getters: {
    user: (state) => JSON.parse(state.access),
    isLogged: (state) => !!JSON.parse(state.access),
    isExpired(state) {
      const exp = new Date(JSON.parse(state.access)['.expires']);
      return new Date() >= exp;
    },
    isConfirmed: (state) => JSON.parse(state.access).isConfirmed === 'True',
    can: (state, getters) => (role) => {
      if (getters.isLogged) {
        return JSON.parse(state.access).roles.split(',').includes(role);
      }
      return false;
    },
  },
  mutations: {
    setToken(state, data) {
      state.access = JSON.stringify(data);
      localStorage.setItem('access', state.access);
      if (data) {
        // eslint-disable-next-line
        Vue.prototype.$http.defaults.headers.common['Authorization'] =
          `Bearer ${data.access_token}`;
      }
    },
  },
  actions: {
    login(ctx, { data }) {
      ctx.commit('setToken', data);
    },
    logout(ctx) {
      ctx.commit('setToken', null);
    },
    confirm(ctx) {
      const access = JSON.parse(ctx.state.access);
      access.isConfirmed = 'True';
      ctx.commit('setToken', access);
    },
    get(ctx, data) {
      if (typeof data === 'string') {
        return Vue.prototype.$http.get(data);
      }
      const { params, api } = data;
      return Vue.prototype.$http.get(api, { params });
    },
    post(ctx, { data, api }) {
      return Vue.prototype.$http.post(api, QS.stringify(data));
    },
    put(ctx, { data, api }) {
      return Vue.prototype.$http.put(api, QS.stringify(data));
    },
    patch(ctx, { data, api }) {
      return Vue.prototype.$http.patch(api, QS.stringify(data));
    },
    delete(ctx, data) {
      if (typeof data === 'string') {
        return Vue.prototype.$http.delete(data);
      }
      const { api } = data;
      return Vue.prototype.$http.delete(api);
    },
  },
});

export default store;
